import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-journaux-show',
  templateUrl: './journaux-show.component.html',
  styleUrls: ['./journaux-show.component.scss']
})
export class JournauxShowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
